import { FC, ChangeEvent } from 'react';
import { css } from '@emotion/react';
import isEqual from 'lodash-es/isEqual';
import { TeamChatTypes } from '@frontend/api-team-chat';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { RadioField, useFormField } from '@frontend/design-system';
import { ATTACHMENT_FILTER_OPTIONS } from '../../../constants';
import { useKeywordSearchStore } from '../../../providers/keyword-search.provider/keyword-search.provider';
import { FilterChipPopover } from '../../common/filter-chip-popover/filter-chip-popover.component';

interface AttachmentFilterProps {
  focusSearchBar: () => void;
}

export const AttachmentFilter: FC<AttachmentFilterProps> = ({ focusSearchBar }) => {
  const { t } = useTranslation('team-chat');
  const { attachmentType, setAttachmentType } = useKeywordSearchStore(['attachmentType', 'setAttachmentType']);

  const fieldProps = useFormField({ type: 'radio', value: attachmentType ?? '' }, [attachmentType]);

  const displayValue = attachmentType ? t('Has: {{label}}', { label: attachmentType }) : t('Has');

  const onClear = () => {
    fieldProps.onChange({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
  };
  const onApply = () => {
    setAttachmentType(fieldProps.value as TeamChatTypes.Attachment['type']);
    focusSearchBar();
  };

  return (
    <>
      <FilterChipPopover
        value={displayValue}
        onClear={onClear}
        onApply={onApply}
        isApplyDisabled={isEqual(fieldProps.value, attachmentType)}
        trackingId='team-chat-2.0-keyword-search-attachment-filter-button'
        clearButtonTrackingId='team-chat-2.0-keyword-search-attachment-filter-clear-button'
        applyButtonTrackingId='team-chat-2.0-keyword-search-attachment-filter-apply-button'
        hasValue={!!attachmentType}
      >
        <RadioField name={'Attachment'} css={styles.content} {...fieldProps}>
          {ATTACHMENT_FILTER_OPTIONS.map((option) => (
            <RadioField.Radio
              key={option.id}
              value={option.id}
              trackingId={`team-chat-2.0-keyword-search-attachment-filter-${option.id}}`}
            >
              {option.label}
            </RadioField.Radio>
          ))}
        </RadioField>
      </FilterChipPopover>
    </>
  );
};

const styles = {
  content: css({
    padding: theme.spacing(1, 2),
  }),
};
